import styled from 'styled-components';
import Layout from 'components/Layout';
import StyledContentType from 'components/Layout/Content/types';
import StyledWysiwygBlock from 'blocks/Wysiwyg/styles';
import StyledCopy from 'components/Copy/styles';
import TiledSand from 'assets/images/tiled-sand-bkg.jpg';
import TopSand from 'assets/images/top-sand-bkg.png';
import BottomSand from 'assets/images/main-sand-bkg.png';
import CloudsLeftImg from 'assets/images/clouds-left.png';
import CloudsRightImg from 'assets/images/clouds-right.png';
import {StyledBlockInner} from 'components/Block/styles'

export const StyledContent = styled(Layout.Content)(
  ({ theme: { colors  }}: StyledContentType) => `
    position: relative;
    ${StyledCopy} {
      background: ${colors.lightGreyBlue};
      margin: auto;
      padding: 16px;
    }
`,
);

export const HeroLandscape = styled.div(
  ({ theme: { colors, mobileView } }) => `
    position: relative;
    height: 20vh;
    ${mobileView} {
      height: 10vh;
    }
    .sun {
      max-width: 418px;
      position: absolute;
      top: 5%;
      left: 50%;
      z-index: 1;
      width: auto;
      max-height: 150%;
    }
    .mountain-left, .mountain-right {
      position: absolute;
      bottom: 0;
      max-height: 100%;
      width: auto;
      z-index: 2;
      ${mobileView} {
        max-width: 150%;
      }
    }
    .mountain-left {
      left: 0;
      transform: translateX(-7%);
      max-width: 80%;
      ${mobileView} {
        transform: translateX(-25%);
      }
    }
    .mountain-right {
      right: 0;
      max-height: 70%;
      
      ${mobileView} {
        transform: translateX(35%);
      }
    }
    .tree {
      position: absolute;
      max-width: 315px;
      width: 25vw;
      bottom: 0;
      z-index: 1;
      transform: translate(-20%, -10%);
    }
    .trees {
      position: absolute;
      right: 0;
      max-width: 332px;
      width: 28vw;
      bottom: 0;
      z-index: 2;
      transform: translate(45%, -10%);
    }
    .edge {
      position: absolute;
      bottom:0;
      transform: translateY(10%);
      width: 100%;
      z-index: 2;
    }
`,
);

export const HeroBackground = styled.div(
  ({ theme: { colors, mobileView, tabletView, spacing, header } }) => `
    position: relative;
    padding-top: ${spacing.x8};
    margin-top: -5px;
    background-image: linear-gradient(to bottom, ${colors.pigPink} 18%, ${colors.pigPink} 27%, #c996b7 33%, #b6a3c1 45%, #a4b0cc 54%, ${colors.lightGreyBlue} 62%);
    .Cloud20yrs {
      position: absolute;
      width: 10vw;
      max-width: 250px;
      top: 25%;
      left: 20%;
      z-index: 6;
      ${tabletView} {
        width: 15vw;
        left: 15%;
      }
      ${mobileView} {
        top: auto;
        left: 50%;
        bottom: 15%;
        transform: translate(-50%, 0);
        width: 20vw;
      }
    }
  `);

export const BlockBackground = styled.div(
  ({ theme: { colors, mobileView, spacing } }) => `
      background-image: url(${TiledSand});
      background-position: top center;
      background-size: 15vw auto;
      position: relative;
      z-index: 5;
      margin-top: 5vw;
      margin-bottom: 6vw;
      > section {
        top: -5vw;
        position: relative;
      }
      &:before {
        content: "";
        position: absolute;
        bottom: calc(100% - 1px);
        left: 0;
        width: 100%;
        background-image: url(${TopSand});
        background-size: 15vw auto;
        background-repeat: repeat-x;
        background-position: bottom center;
        padding-top: 7.5vw;
        z-index: -1;
      }
      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background-image: url(${BottomSand});
        background-size: 101% auto;
        background-position: bottom center;
        background-repeat: no-repeat;
        padding-top: 26%;
        z-index: -1;
        transform: translateY(6vw);
      }
      ${mobileView} {
        > section {
          top: ${spacing.x2};
        }
        .womanChair, .manVan {
          display: none;
        }
      }
      .womanChair {
        position: absolute;
        bottom: 100%;
        right: 10%;
        max-width: 424px;
        width: 35vw;
        transform: translateY(-6vw);
      }
      .manVan {
        position: absolute;
        bottom: 100%;
        left: 15%;
        max-width: 288px;
        width: 20vw;
        transform: translateY(-5vw);
        
      }
  `
)
export const CloudsLeft = styled.div `
    background-image: url(${CloudsLeftImg});
    background-position: top right;
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    width: 45%;
    max-width: 600px;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 0;
`;
export const CloudsRight = styled.div `
  background-image: url(${CloudsRightImg});
  background-position: top left;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  max-width: 600px;
  width: 45%;
  z-index: 0;
`;
